.counter {
  margin-top: 4px;
  font-size: 13px;
}

.counterError {
  color: var(--color-text-error);
}
